import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import type { Vehicle } from '../../types/Vehicle';
import { vehiclesApi } from '../../api/vehicles.api';
import type { RootState } from '../store';

const vehiclesAdapter = createEntityAdapter<Vehicle, string>({
  selectId: (vehicle: Vehicle) => vehicle.id,
});

export const vehiclesReducer = createSlice({
  name: 'vehiclesReducer',
  initialState: vehiclesAdapter.getInitialState({
    count: 0,
  }),
  reducers: {
    updateVehicle: vehiclesAdapter.updateOne,
    clearVehicles: state => {
      vehiclesAdapter.removeAll(state);
      state.count = 0;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(vehiclesApi.endpoints.getVehicles.matchFulfilled, (state, action) => {
      vehiclesAdapter.removeAll(state);
      vehiclesAdapter.addMany(state, action.payload.results);
      state.count = action.payload.count;
    });
  },
  selectors: {
    selectCount: state => state.count,
  },
});

export const { updateVehicle, clearVehicles } = vehiclesReducer.actions;

export const vehiclesSelector = vehiclesAdapter.getSelectors<RootState>(state => {
  return state.vehiclesReducer;
});
export const vehiclesCountSelector = vehiclesReducer.selectors.selectCount;
